<header class="ph">
  <div>
    <span class="eyebrow">{{ eyebrow() }}</span>
    <h1>{{ title() }}</h1>
    @if (lead()) {
      <p class="lead">{{ lead() }}</p>
    }
  </div>
  <div class="actions"><ng-content /></div>
</header>
